import { useState } from "react";
import { content } from "./content";
import { HiMenuAlt2 } from "react-icons/hi";
import { createElement } from "react";

const Navbar = () => {
    

  const { nav } = content;
  const [showMenu, setShowMenu] = useState(true);
  const [active, setActive] = useState(0);

  return (
    <div className="w-full flex justify-center">
      <div
        className={`fixed  z-[999] flex items-center gap-5 bg-violet-900/40  px-6 py-3 backdrop-blur-md rounded-full ${
           "bottom-10" 
        }`}
      >
        {nav.map((item, i) => (
          <a
            key={i}
            href={item.link}
            onClick={() => setActive(i)}
            className={`text-2xl p-2.5 rounded-full
     ${i === active && "bg-dark_primary "} `}
          >
            {createElement(item.icon)}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
